import React from "react";
import Home from "./components/Home";
import SpeakerApplication from "./components/SpeakerApplication";
import AgendaNew from "./components/AgendaNew";
import { BrowserRouter , Routes, Route } from "react-router-dom";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import "./App.css";

function App() {

  const appVersion = appversion.version;
  
  return (
    // <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
    <div>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false}
        metaFileDirectory={process.env.PUBLIC_URL}
      >
        <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/*" element={<Home />} />
        {/* <Route path="/speakerapplication" element={<SpeakerApplication />} /> */}
        {/* <Route path="/agenda" element={<AgendaNew />} /> */}
      </Routes>
      </>
      </CacheBuster>
    </div>
  // </BrowserRouter>
  );
}
export default App;